import { apiList } from "../api/apiList";
import axiosInstance from "../api/axiosInstance";
import axiosInstance2 from "../api/axiosInstance2";

const goalResultService = {
  getAllGoals: () => axiosInstance.get(apiList.allGoalResultApi),
  getBackgroundStatus: (str) => axiosInstance2.get(`${apiList.baseUrl909}${apiList.backgroundStatusApi}/${str}`),

  getResultWithVouchers: (url,payload) => axiosInstance2.post(url,payload), // all in one service
  calculateVouchers: (url,payload) => axiosInstance.post(url,payload), // all in one service
  addGoalMultiple: (url,payload) => axiosInstance.post(url, payload), // all in one service
  updateGoalResult: (url,payload) => axiosInstance.post(url, payload),
  getResultHub : (str) => axiosInstance.get(`${apiList.baseUrl}${apiList.resultHubApi}/${str}`),
  getResultWithOdds : (str) => axiosInstance2.get(`${apiList.liveEventControlApi}/${str}`),
  updateTaxPercent : (type,id) => axiosInstance2.post(`${apiList.updateTaxPercentApi}/${type}/${id}`),
  removeEvent : (payload) => axiosInstance2.put(`${apiList.removeEventApi}`,payload),
  getVouchers :(payload) => axiosInstance2.post(`${apiList.getVouchersApi}`,payload),
  saveResultHub : (payload) => axiosInstance.post(`${apiList.baseUrl}${apiList.resultHubApi}`, payload),
  updateEventTime : (payload) => axiosInstance2.put(`${apiList.updateEventTimeApi}`,payload),
};

export default goalResultService;
